import {Component, OnInit} from '@angular/core';
import {ChartElement} from './ChartElement';
import {Newcomer} from './Newcomer';
import {ChartsService} from './charts.service';
import {ToastrService} from 'ngx-toastr';
import {StatusCode} from './StatusCode';
import {Messages} from './Messages';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'charts';
  newcomer: Newcomer = {artist: null, name: null};
  charts: ChartElement[] = [];
  voteButtonVisible = false;
  timeout = false;
  userid = '';
  consent = false;
  open: boolean = null;
  isInEu = false;
  toastConfig = {
    positionClass: 'toast-bottom-right',
  };

  constructor(private chartsService: ChartsService,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.checkEu();
    this.getStatus();
    this.checkConsent();
    this.getCharts();
  }

  private checkEu(): void {
    this.isInEu = Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf('Europe') === 0;
  }

  private getStatus(): void {
    console.log(this.open);
    this.chartsService.isOpen().subscribe(data => {
      this.open = data;
    });
  }

  private checkConsent(): void {
    if (this.getId()) {
      this.consent = true;
    }
  }

  public giveConsent(): void {
    this.createId();
    this.checkConsent();
  }

  private getCharts(): void {
    this.chartsService.getCharts().subscribe(data => {
      if (data) {
        this.voteButtonVisible = true;
        this.charts = data;
        console.log(this.charts);
      }
    });
  }

  sendVote(): void {
    if (!this.userid) {
      this.toastr.error(Messages.ERROR_SUBMIT_VOTE, 'Charts', this.toastConfig);
      return;
    }
    this.chartsService.sendVote(this.charts, this.userid).subscribe(data => {
      switch (data) {
        case StatusCode.SUCCESS:
          this.toastr.success(Messages.SUCCESS_SUBMIT_VOTE, 'Charts', this.toastConfig);
          this.charts.forEach(element => {
            element.ticked = false;
          });
          break;

        case StatusCode.ALREADY_VOTED:
          this.toastr.error(Messages.ERROR_ALREADY_VOTED, 'Charts', this.toastConfig);
          break;

        default:
          this.toastr.error(Messages.ERROR_SUBMIT_VOTE, 'Charts', this.toastConfig);
          break;
      }
    });
  }

  sendNewcomer(): void {
    const newcomer = this.newcomer;
    if (!newcomer.artist || !newcomer.name) {
      this.toastr.error(Messages.ERROR_INCOMPLETE_NEWCOMER, 'Charts', this.toastConfig);
    } else {
      this.chartsService.sendNewcomer(newcomer)
      .subscribe(response => {
        if (response.artist === newcomer.artist && response.name === newcomer.name) {
          this.toastr.success(`${newcomer.artist} - ${newcomer.name}`, Messages.SUCESS_SUBMIT_NEWCOMER, this.toastConfig);
          this.newcomer = {artist: null, name: null};
        } else {
          this.toastr.error(`${newcomer.artist} - ${newcomer.name}`, Messages.ERROR_SUBMIT_NEWCOMER, this.toastConfig);
        }
      });
    }
  }

  getId(): string {
    this.userid = localStorage.getItem('USERID');
    console.log(this.userid);
    return this.userid;
  }

  createId(): void {
    const userid = this.createRandomId();
    localStorage.setItem('USERID', userid);
  }

  createRandomId(): string {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const length = 56;

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }
}
